export const Language = {
  en: 'en-GB',
  fr: 'fr-FR',
  pl: 'pl-PL',
};
